import Cookies from 'js-cookie'

// Safari 开启无痕模式的时候，localStorge不支持setItem
let isStorage = true
export class StoreUtil {
  static setItem(key, val) {
    try {
      localStorage.setItem(key, val)
      isStorage = true
    } catch (e) {
      isStorage = false
      Cookies.set(key, val, { expires: 365 })
    }
  }
  static getItem(key) {
    if (isStorage) {
      return localStorage.getItem(key)
    } else {
      return Cookies.get(key) // => 'value'
    }
  }
}
